export default __webpack_public_path__ + "static/media/t1.9c3029ca.jpg";